import {Entity} from '../core/entity/core.base.entity';
import {Column} from '../core/entity/core.entity.column';
import {JoinColumn} from '../core/entity/core.entity.join.column';
import {EntityTable} from '../core/entity/core.entity.table.decorator';
import {EnvironmentKind} from '../enum/environment.kind';
import {FieldRelationKind} from '../enum/field.relation.kind';
import {FieldTypeKind} from '../enum/field.type.kind';
import {INickOptionsField} from '../interface/nick.i.options.field';
import {EnumEntity} from './enum.entity';
import {ModelEntity} from './model.entity';

@EntityTable('field', '690d8463-4367-4fd0-9200-3e2399b6288c')
export class FieldEntity extends Entity {

    @Column(FieldTypeKind.STRING)
    public name: string;

    @Column(FieldTypeKind.STRING)
    public columnName: string;

    @Column(FieldTypeKind.LONG)
    public type: FieldTypeKind;

    @Column(FieldTypeKind.GUID, false, false, true)
    public aliasId: string;

    @Column(FieldTypeKind.ENUM, false)
    public environmentKind: EnvironmentKind;

    @JoinColumn(FieldTypeKind.GUID, ModelEntity, true, false, FieldRelationKind.BELONGS_TO, 'model', 'aliasId', 'modelType')
    public modelType: string;

    @JoinColumn(FieldTypeKind.GUID, EnumEntity, true, false, FieldRelationKind.BELONGS_TO, 'enum', 'aliasId', 'enumType')
    public enumType: string;

    @Column(FieldTypeKind.ANY)
    public options: INickOptionsField;
}
